import { css } from '@emotion/react';
import { useTheme } from '@mui/material/styles';
import { useEffect, useMemo } from 'react';

const useGlobalStyle = () => {
  const theme = useTheme();

  useEffect(() => {
    const updateScrollX = () => {
      document.documentElement.style.setProperty(
        '--scroll-x',
        `${window.scrollX}px`,
      );
    };

    updateScrollX();

    window.addEventListener('scroll', updateScrollX, { passive: true });
    window.addEventListener('resize', updateScrollX);

    return () => {
      window.removeEventListener('scroll', updateScrollX);
      window.removeEventListener('resize', updateScrollX);
    };
  }, []);

  const globalStyle = useMemo(
    () => css`
      html,
      body,
      #root {
        height: 100%;
      }

      body {
        min-width: 1440px;
        background: ${theme.body.background};
        @media screen and (min-width: ${theme.breakpoints.values.lg}px) {
          overflow-x: hidden;
        }
      }

      a {
        text-decoration: none;
      }

      .MuiCardHeader-action .MuiIconButton-root {
        padding: 4px;
        width: 28px;
        height: 28px;
      }

      // google maps
      .infoBox {
        overflow: visible !important;
      }

      // notistack
      .notistack-SnackbarContainer {
        top: 66px;
        white-space: pre-line;
        max-height: calc(100% - 114px);
        pointer-events: none;
        z-index: 1500;

        body[data-maintenance='true'] & {
          top: 104px;
        }
      }
      #CookiebotWidget {
        position: fixed !important;
        top: 14px !important;

        left: calc(1440px - 16px - 36px - var(--scroll-x, 0px)) !important;
        right: auto !important;

        min-width: 36px !important;
        min-height: 36px !important;

        @media (min-width: ${theme.breakpoints.values.lg}px) {
          right: 16px !important;
          left: auto !important;
        }
      }
      #CookiebotWidget button.CookiebotWidget-logo svg {
        width: 36px !important;
        height: 36px !important;
      }
    `,
    [theme],
  );

  return globalStyle;
};

export default useGlobalStyle;
